import { render, staticRenderFns } from "./attachment.component.vue?vue&type=template&id=2f08087c"
import script from "./attachment.component.vue?vue&type=script&lang=js"
export * from "./attachment.component.vue?vue&type=script&lang=js"
import style0 from "./attachment.component.vue?vue&type=style&index=0&id=2f08087c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports